import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ISettings } from '@/api/routes/settings/types';

import { fetchSettings } from './actionCreators';

interface InitialState {
  settings: ISettings | null,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  settings: null,
  isLoading: false,
  error: '',
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    updateSettings: (state, action: PayloadAction<ISettings>) => {
      state.settings = action.payload;
    },
  },
  extraReducers: {
    [fetchSettings.fulfilled.type]: (state, action: PayloadAction<ISettings>) => {
      state.isLoading = false;
      state.error = '';
      state.settings = action.payload;
    },
    [fetchSettings.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchSettings.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { updateSettings } = settingsSlice.actions;
export default settingsSlice.reducer;
